import { render, staticRenderFns } from "./ErrorComp.vue?vue&type=template&id=62ff1fc6&scoped=true&"
import script from "./ErrorComp.vue?vue&type=script&lang=js&"
export * from "./ErrorComp.vue?vue&type=script&lang=js&"
import style0 from "./ErrorComp.vue?vue&type=style&index=0&id=62ff1fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ff1fc6",
  null
  
)

export default component.exports